import React from "react";
import { Row, Col, Typography, Divider } from "antd";
import dayjs from "dayjs";
import { numberFormat, convertNumberToWords } from "../../../lib/functions";
import InstitutionProfile from "../../../components/common/InstitutionProfile";
import "../../CustomerReceipts/components/customerReceiptVoucher.css";

const { Title, Text } = Typography;

// Same layout/CSS as CustomerReceiptVoucherBody (the one receipt type in this
// app that already works without the Puppeteer PDF pipeline -- that pipeline
// can't run on the current hosting, so this is deliberately browser-print-only,
// not a WhatsApp/auto-download button). Covers both Payment and Receive,
// branching on tran_type since they're the same record shape.
const AdvanceTransactionReceiptBody = ({ data }) => {
  if (!data) return null;

  const isPayment = data.tran_type === "payment";
  const title = isPayment ? "PAYMENT RECEIPT" : "RECEIVE RECEIPT";
  const partyLabel = isPayment ? "Paid To" : "Received From";
  const accountLabel = isPayment ? "Paid From" : "Received Into";

  const receiptNo = `${isPayment ? "PAY" : "RCV"}-${String(data.tran_id || "")
    .replace(/-/g, "")
    .slice(0, 8)
    .toUpperCase()}`;

  const amount = Number(data.tran_amount || 0);
  const currency = data.currency || "INR";

  return (
    <div className="receipt-voucher">
      {/* HEADER */}
      <Row justify="space-between" align="top">
        <Col>
          <InstitutionProfile />
        </Col>
        <Col style={{ textAlign: "right" }}>
          <Title level={2}>{title}</Title>
          <Text>Receipt No: {receiptNo}</Text><br />
          <Text>Date: {dayjs(data.tran_date).format("DD-MM-YYYY")}</Text>
        </Col>
      </Row>

      <Divider />

      {/* PARTY */}
      <Row>
        <Col span={12}>
          <Text strong>{partyLabel}</Text><br />
          <Text>{data.acc_name}</Text>
        </Col>
        <Col span={12}>
          <Text strong>{accountLabel}</Text><br />
          <Text>{data.tran_acc_name}</Text>
        </Col>
      </Row>

      <Divider />

      {/* TOTALS */}
      <div className="receipt-totals">
        <div className="row">
          <span>Amount</span>
          <strong>{numberFormat(amount)}</strong>
        </div>
      </div>

      <Divider />

      <Text italic>
        In Words: {convertNumberToWords(amount, currency)}
      </Text>
      <br />
      <Text>Description: {data.narration || "-"}</Text>

      {/* FOOTER */}
      <div className="receipt-footer">
        <div className="sign">
          <div className="line" />
          <Text>{isPayment ? "Received By" : "Prepared By"}</Text>
        </div>
        <div className="sign">
          <div className="line" />
          <Text>Authorized By</Text>
        </div>
      </div>
    </div>
  );
};

export default AdvanceTransactionReceiptBody;
